import React, { useEffect, useState } from 'react';
import { Label, FormGroup } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../components/custom/BackButton';
import ActionIcon from '../../../components/custom/ActionIcon';
import { Input } from 'reactstrap';
import CustomSwitch from '../../../components/custom/CustomSwitch';
import Select from '../../../components/Select';
import { IssueReport, IssueReportStatus, SelectOption } from '../../../globals/interfaces';
import { UpdateIssue } from '.';

const statusArray: Array<IssueReportStatus> = ['OPEN', 'IN_PROGRESS', 'RESOLVED', 'CLOSED'];
const statusOptions: Array<SelectOption<IssueReportStatus>> = statusArray.map(item => ({ label: item, value: item }));

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    issue: IssueReport;
    updateIssue: UpdateIssue;
}

export default function AddNotesModal({
    modal,
    setModal,
    issue,
    updateIssue
}: Props) {

    const [notifyUser, setNotifyUser] = useState(false);
    const [status, setStatus] = useState<IssueReportStatus>();
    const [notes, setNotes] = useState<string>();

    useEffect(() => {
        if (issue) {
            setStatus(issue.status)
        }
    }, [issue]);

    useEffect(() => {
        setNotes('');
        setNotifyUser(false);
    }, [modal]);

    const handleUpdateIssue = async () => {
        await updateIssue(status, notes, notifyUser);
        toggle();
    }

    const toggle = () => setModal(!modal);

    return (
        <Modal isOpen={modal} toggle={toggle} size={'lg'}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Add Note</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label>Note</Label>
                    <Input type={'textarea'} value={notes} onChange={e => setNotes(e.target.value)} />
                </FormGroup>
                <CustomSwitch
                    label={'Notify User with this note'}
                    value={notifyUser}
                    handleSwitch={setNotifyUser}
                />
                <Select<IssueReportStatus>
                    options={statusOptions}
                    value={status}
                    onChange={option => setStatus(option.value)}
                    width={150}
                    label={'Change Status'}
                />
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer>
                        <ActionIcon type={'save'} onClick={handleUpdateIssue} disabled={!notes || !notes.length} />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{ update?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;